import { jsx as o } from "react/jsx-runtime";
import { useState as s, useRef as c, useEffect as l } from "react";
import { ValueDescription as p } from "@biron-data/react-components";
import { u as f } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { useLanguageResolver as m } from "@biron-data/react-contexts";
const y = ({ type: e }) => {
  const i = m(), [t, n] = s("right"), r = c();
  return l(() => {
    r.current.getBoundingClientRect().x > window.innerWidth - 600 && t !== "bottom" && n("bottom");
  }, [t]), /* @__PURE__ */ o(u, { ref: r, children: /* @__PURE__ */ o(
    p,
    {
      title: i.get(`filter.type.${e}.title`),
      description: i.get(`filter.type.${e}.description`),
      placement: t
    }
  ) });
}, u = f.div`
  display: flex;
`;
export {
  y as default
};
//# sourceMappingURL=FilterTypeDescription.js.map
